<p-toast *transloco="let translate"
         class="mobile-launch-toast"
         key="mobileLaunchPopup"
         position="bottom-center"
         [preventOpenDuplicates]=true
>

  <ng-template pTemplate="message">
    <div class="flex flex-column" style="flex: 1">
      <div class="text-center">
        <img class="icon" src="/resources/favicons/pwa-icon-120px.png"/>
        <h1 class="title">{{translate('mobileLauncher.modal_open_in_app')}}</h1>
      </div>
      <div class="buttons">
        <aero-button [aeroStyle]="buttonStylePrimary"
                     (click)="openPressed()"
                     label="{{translate('mobileLauncher.modal_open_in_app_confirm')}}">
        </aero-button>
        <aero-button [aeroStyle]="buttonStyleSecondary"
                     (click)="noPressed()"
                     label="{{translate('mobileLauncher.button_no')}}">
        </aero-button>
      </div>
    </div>
  </ng-template>
</p-toast>
